import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IDataDiagnosticos } from '../interfaces/diagnosticos.interface';
import { IndexdbService } from '../../core/database/indexdb.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceFormDiagnosticoService {
  private readonly indexDbService: IndexdbService = inject(IndexdbService);

  getDiagnosticos(): Observable<IDataDiagnosticos[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.diagnosticos ?? [])
    );
  }
}
